import { render, staticRenderFns } from "./HowToRedeem.vue?vue&type=template&id=446b5c8d&scoped=true"
import script from "./HowToRedeem.vue?vue&type=script&lang=js"
export * from "./HowToRedeem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446b5c8d",
  null
  
)

export default component.exports